<!--  -->
<template>
	<div class="content">
		<cx-head v-if="windowWidth < 768" />
		<b-container fluid>
			<img class="top_img" width="100%"
				:src="windowWidth >= 768 ? '../../static/img/service/top_img.png' : '../../static/img/service/top_img1.png'" />
		</b-container>

		<div class="mianbao" toggleable="lg" :class="{ isFixed: isFixed }">
			<div class="mianbao_view">
				<div v-for="(item, index) in mianbaoList" :key="index" class="mianbao_item"
					:class="{ active: index == i }" @click="goAnchor(item.id, index)">
					{{ item.label }}</div>
			</div>
			<div class="mianbao_min">
				<div v-for="(item, index) in mianbaoList" :key="index" :class="{ active: index == i }"
					@click="goAnchor(item.id, index)">{{ item.label }}</div>
			</div>
		</div>

		<div class="middleContent" v-if="windowWidth >= 768">
			<div id="title1">
				<h4>营地联盟</h4>
				<div class="flex flex-row justify-between margin-top-lg">
					<div class="leftView">
						<p class="margin-right-sm" style="line-height: 2;">
							"约你游"以湖南长沙为大本营，通过约你游（长沙）房车露营飞行基地向全国发展，通过自营、外签营地两种方式扩张服务范围，为消费者提供一站式房车综合旅行服务。
							截至2023年3月，"约你游"合作营地已超500家，包含南宁·青瓦房露营地、
							泰安·吉星营地、途居·南通开沙岛等营地。
						</p>
						<img class=" margin-top-xs" width="878" height="722" src="../../static/img/service/map.png" />
					</div>
					<div class="rightView">
						<!-- <img width="453" height="502" src="../../static/img/service/data.png" /> -->
						<div class="campCase shadow-blur">
							<div class="title">合作营地</div>
							<div class="caseView">
								<div class="flex flex-row" style="margin-top: 15px;cursor: pointer;"
									v-for="(item, index) in pageData.ydalList" :key="index"
									@click="gotoCampDetail(item.id)">
									<img width="165" height="125" style="border-radius: 10px;" :src="item.cover" />
									<div style="margin-left: 20px;">
										<div class="text-222" style="line-height: 2;font-size: 16px;">{{ item.title }}
										</div>
										<div class="text-666" style="line-height: 1.8;">{{ item.description }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="middleContent_min" v-else>
			<div id="title1">
				<h4>营地联盟</h4>
				<div class="margin-top-sm">
					<div class="leftView">
						<p class="" style="line-height: 2;">
							"约你游"以湖南长沙为大本营，通过约你游（长沙）房车露营飞行基地向全国发展，通过自营、外签营地两种方式扩张服务范围，为消费者提供一站式房车综合旅行服务。
							截至2023年3月，"约你游"合作营地已超500家，包含南宁·青瓦房露营地、
							泰安·吉星营地、途居·南通开沙岛等营地。
						</p>
						<img class="margin-top-xs" width="334" height="274" src="../../static/img/service/map1.png" />
					</div>
					<div class="rightView">
						<!-- <img width="453" height="502" src="../../static/img/service/data.png" /> -->
						<div class="campCase shadow-blur">
							<div class="title">合作营地</div>
							<div class="caseView">
								<div class="flex flex-row" style="margin-top: 15px;cursor: pointer;"
									v-for="(item, index) in pageData.ydalList" :key="index"
									@click="gotoCampDetail(item.id)">
									<img width="120" height="90" style="border-radius: 10px;" :src="item.cover" />
									<div style="margin-left: 20px;">
										<div class="text-222" style="line-height: 2;font-size: 16px;">{{ item.title }}
										</div>
										<div class="text-666 margin-top-xs" style="line-height: 1.8;">{{
											item.description }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="middleContent2" id="title2" v-if="windowWidth >= 768">
			<div class="titleView">
				<div class="titleView_box">
					<h4>景区合作</h4>
					<div class="typeList">
						<div class="type_item" :class="{ active: typeCur == 0 }" @click="typeCur = 0">
							<img width="27.5" src="../../static/img/service/icon1.png" />
							<p>景区联盟</p>
						</div>
						<div class="type_item" :class="{ active: typeCur == 1 }" @click="typeCur = 1">
							<img width="27.5" src="../../static/img/service/icon2.png" />
							<p>沉浸式文旅</p>
						</div>
					</div>
				</div>
			</div>
			<div class="areaView" v-if="typeCur == 0">
				<div class="flex flex-row justify-between margin-top-lg">
					<div class="areaLeft text-222">
						<h5>景区联盟业务合作</h5>
						<div class="h5Bottom"></div>
						<p class="text-222">
							约你游为合作景区提供产品研发、市场营销、景区托管运营、设备采集安装落地等服务，通过专业的综合策划能力及文旅线上线下供应链整合能力不断为文旅目的地提供专业化、标准化、品牌化的服务，实现流量、招商、消费等综合运营能力的全面提升。
						</p>
						<h5 class="margin-top-xl">商务合作</h5>
						<p>联系电话：18874768986</p>
						<p>邮箱：liuli@ezagoo.com</p>
					</div>
					<div class="img-box flex-sub">
						<div class="img-box-inner" v-if="pageData.jqlmList && pageData.jqlmList.length > 0"
							style="cursor: pointer;">
							<img @click="gotoScenicDetail(pageData.jqlmList[0].id)" :src="pageData.jqlmList[0].cover"
								alt="">
							<!-- <img @click="playVedio(nameId(index), index)" class="play_btn" width="50"
								src="../../static/img/service/ic_play.png" /> -->
						</div>
					</div>
				</div>
				<div class="swiperView">
					<Swiper class="my-swipe swiper" :options="swiperOption">
						<swiper-slide v-for="(item, index) in pageData.jqlmList" :key="index" v-if="index > 0">
							<img width="345" height="250" :src="item.cover" @click="gotoScenicDetail(item.id)"
								style="cursor: pointer;" />
							<div class="text-222 margin-top-xs">{{ item.title }}</div>
						</swiper-slide>
					</Swiper>
					<div class="swiperBtn">
						<div class="swiper-button-prev" slot="button-prev"></div>
						<div class="swiper-button-next" slot="button-next"></div>
					</div>
				</div>
			</div>
			<div class="areaView" v-else-if="typeCur == 1">
				<div class="flex flex-row justify-between margin-top-lg">
					<div class="areaLeft text-222">
						<h5>沉浸式文旅</h5>
						<div class="h5Bottom"></div>
						<p class="text-222">
							沉浸式文旅是“约你游”旗下的重要业务版块，是剧情沉浸文旅的专业运营平台，以打造中国景区的剧情沉浸文旅为愿景，以原创文旅核心内容为纽带，链接景区、创作者和消费者，实现沉浸文旅产供销一体化运营。
						</p>
						<h5 class="margin-top-xl">商务合作</h5>
						<p>联系电话：18975833504</p>
						<p>邮箱：zhongzeyou@ezagoo.com</p>
					</div>
					<div class="img-box flex-sub">
						<div class="img-box-inner" v-if="pageData.cqswlList && pageData.cqswlList.length > 0"
							style="cursor: pointer;">
							<img @click="gotoScenicDetail(pageData.cqswlList[0].id)" :src="pageData.cqswlList[0].cover"
								alt="">
							<!-- <img @click="playVedio(nameId(index), index)" class="play_btn" width="50"
								src="../../static/img/service/ic_play.png" /> -->
						</div>
					</div>
				</div>
				<div class="flex justify-between flex-row" style="margin-top: 40px;">
					<div class="" v-for="(item, index) in pageData.cqswlList" :key="index"
						@click="gotoScenicDetail(item.id)" style="cursor: pointer;">
						<img width="345" height="250" :src="item.cover" />
						<div class="text-222 margin-top-xs">{{ item.title }}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="middleContent2_min" id="title2" v-else>
			<div class="titleView">
				<div class="titleView_box">
					<h4>景区合作</h4>
					<div class="typeList">
						<div class="type_item" :class="{ active: typeCur == 0 }" @click="typeCur = 0">
							<img width="55" src="../../static/img/service/icon1.png" />
							<p>景区联盟</p>
						</div>
						<div class="type_item" :class="{ active: typeCur == 1 }" @click="typeCur = 1">
							<img width="55" src="../../static/img/service/icon2.png" />
							<p>沉浸式文旅</p>
						</div>
					</div>
				</div>
			</div>
			<div class="areaView" v-if="typeCur == 0">
				<div class="margin-top-sm">
					<div class="areaLeft text-222">
						<h5>景区联盟业务合作</h5>
						<div class="h5Bottom"></div>
						<p class="text-222">
							约你游为合作景区提供产品研发、市场营销、景区托管运营、设备采集安装落地等服务，通过专业的综合策划能力及文旅线上线下供应链整合能力不断为文旅目的地提供专业化、标准化、品牌化的服务，实现流量、招商、消费等综合运营能力的全面提升。
						</p>
						<h5 class="margin-top">商务合作</h5>
						<p>联系电话：18874768986</p>
						<p>邮箱：liuli@ezagoo.com</p>
					</div>
				</div>

				<Swiper class="my-swipe swiper margin-top-xs" :options="swiperOption">
					<swiper-slide v-for="(item, index) in pageData.jqlmList" :key="index">
						<img width="100%" height="125" :src="item.cover" @click="gotoScenicDetail(item.id)"
							style="cursor: pointer;" />
						<div class="text-666 margin-top-xs">{{ item.title }}</div>
					</swiper-slide>
				</Swiper>

				<!-- <div class="flex justify-between flex-wrap" style="margin-top: 20px;">
					<div class="margin-top-sm text-center" v-for="(item, index) in pageData.jqlmList" :key="index"
						@click="gotoScenicDetail(item.id)" style="cursor: pointer;width: 49%">
						<img width="100%" height="125" :src="item.cover" />
						<div class="text-666 margin-top-xs">{{ item.title }}</div>
					</div>
				</div> -->
			</div>
			<div class="areaView" v-else-if="typeCur == 1">
				<div class="flex flex-row justify-between margin-top-lg">
					<div class="areaLeft text-222">
						<h5>沉浸式文旅</h5>
						<div class="h5Bottom"></div>
						<p class="text-222">
							沉浸式文旅是“约你游”旗下的重要业务版块，是剧情沉浸文旅的专业运营平台，以打造中国景区的剧情沉浸文旅为愿景，以原创文旅核心内容为纽带，链接景区、创作者和消费者，实现沉浸文旅产供销一体化运营。
						</p>
						<h5 class="margin-top">商务合作</h5>
						<p>联系电话：18975833504</p>
						<p>邮箱：zhongzeyou@ezagoo.com</p>
					</div>
				</div>
				<Swiper class="my-swipe swiper margin-top-xs" :options="swiperOption">
					<swiper-slide v-for="(item, index) in pageData.cqswlList" :key="index">
						<img width="100%" height="125" :src="item.cover" @click="gotoScenicDetail(item.id)"
							style="cursor: pointer;" />
						<div class="text-666 margin-top-xs">{{ item.title }}</div>
					</swiper-slide>
				</Swiper>
				<!-- <div class="flex justify-between flex-wrap" style="margin-top: 20px;">
					<div class="margin-top-sm text-center" v-for="(item, index) in pageData.cqswlList" :key="index"
						@click="gotoScenicDetail(item.id)" style="cursor: pointer;width: 49%;">
						<img width="100%" height="125" :src="item.cover" />
						<div class="text-666 margin-top-xs">{{ item.title }}</div>
					</div>
				</div> -->
			</div>
		</div>

		<div class="middleContent3" id="title3" v-if="windowWidth >= 768">
			<div class="middleContent3_box">
				<h4>房车加盟</h4>
				<div class="flex flex-row justify-between margin-top-lg">
					<img width="700" src="../../static/img/service/img1.png" />
					<img width="700" src="../../static/img/service/img2.png" />
				</div>
			</div>
		</div>
		<div class="margin-top" id="title3" v-else>
			<img width="100%" src="../../static/img/service/img5.png" />
		</div>
		<div class="middleContent4" id="title4">
			<img width="1440" src="../../static/img/service/img3.png" v-if="windowWidth >= 768" />
			<img class="margin-top" width="100%" src="../../static/img/service/img4.png" v-else />
		</div>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import api from '../api/api.js';
	import cxHead from '@/components/cx-head.vue';
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {
			cxHead,
		},
		metaInfo() {
			return {
				title: this.pageName, // set a title
				meta: [
					{
						// set meta
						name: 'keyWords',
						content: this.SeoKeyword,
					},
					{
						name: 'description',
						content: this.SeoDescription,
					},
				],
			};
		},
		data() {
			//这里存放数据
			return {
				isFixed: false,
				windowWidth: window.innerWidth,
				pageName: '',
				SeoKeyword: '',
				SeoDescription: '',
				i: 0,
				mianbaoList: [
					{
						label: '营地联盟',
						path: '#',
						id: '#title1',
					}, {
						label: '景区合作',
						path: '#',
						id: '#title2',
					},
					{
						label: '房车加盟',
						path: '#',
						id: '#title3',
					},
					{
						label: '导游合作',
						path: '#',
						id: '#title4',
					}
				],
				typeCur: 0,
				pageData: {},//页面数据
				swiperOption: {
					// autoplay: {
					// 	disableOnInteraction: false,
					// 	delay: 500,
					// },
					slidesPerView: window.innerWidth > 768 ? 4 : 2.2,
					spaceBetween: window.innerWidth > 768 ? 20 : 12,
					// slidesPerView: 1,
					// loop: true,
					// width: 1040,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					// pagination: {
					// 	el: ".swiper-pagination",
					// 	type: "fraction",
					// },
					on: {
						//监听滑动切换事件，返回swiper对象
						slideChange: () => {
							console.log('轮播图滚动事件  --->');
						},
					},
				},
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			Scroll(e) {
				let that = this;
				let scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
				console.log(scrollTop);
				if (scrollTop > 620 && that.windowWidth > 768) {
					that.isFixed = true;
					if (scrollTop < 1600) {
						that.i = 0
					}
					else if (1600 <= scrollTop && scrollTop < 2800) {
						that.i = 1
					}
					else if (2800 <= scrollTop && scrollTop < 3400) {
						that.i = 2
					}
					else if (3400 <= scrollTop) {
						that.i = 3
					}
				} else {
					that.isFixed = false;
				}
			},
			getSiteData() {
				//获取seo关键字
				let that = this;
				that.$axios
					.post(api.GetSiteData, {})
					.then(function (response) {
						// console.log('seo优化', response);
						let data = response.data;
						that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
						that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
						that.SeoDescription = data.SeoDescription
							? data.SeoDescription
							: '约你游·一站式房车旅游综合服务平台';
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			getHZGYMediaData() {
				let that = this;
				this.$axios
					.post(api.GetHZGYMediaData, {})
					.then(function (response) {
						if (response.status == 200) {
							let data = response.data.data
							// console.log('更多数据', response);
							that.pageData = data;
						}
					})
					.catch(function (error) {
						console.log(error);
					});
			},
			goAnchor(selector, index) {
				this.i = index;
				//跳转锚点
				var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id
				document.body.scrollTop = anchor.offsetTop; // chrome
				document.documentElement.scrollTop = anchor.offsetTop; // firefox
			},
			gotoCampDetail(id) {//跳转营地案例
				// this.$router.push({
				// 	path: 'newsText',
				// 	query: { title: item.Title, date: item.CreateDate, textHtml: item.Content },
				// });
				this.$router.push({
					path: '/campDetail',
					query: { id: id },
				});
			},
			gotoScenicDetail(id) {//跳转景区详情、
				// debugger
				this.$router.push({
					path: '/scenicDetail',
					query: { id: id },
				});
			},
			gotoPlayDetail(id) {//跳转剧本详情
				this.$router.push({
					path: '/playDetail',
					query: { id: id },
				});
			},
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() { },
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			window.addEventListener('scroll', this.Scroll, true);
			this.getSiteData();
			this.getHZGYMediaData();
		},
		beforeCreate() { }, //生命周期 - 创建之前
		beforeMount() { }, //生命周期 - 挂载之前
		beforeUpdate() { }, //生命周期 - 更新之前
		updated() { }, //生命周期 - 更新之后
		beforeDestroy() { }, //生命周期 - 销毁之前
		destroyed() { }, //生命周期 - 销毁完成
		activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style lang='scss' scoped>
	//@import url(); 引入公共css类
	.content {
		padding-bottom: 90px;
	}

	.container-fluid {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.mianbao {
		// display: flex;
		// flex-direction: row;
		// align-items: center;
		background: #fbfbfb;
		font-size: 16px;
		// padding: 15px 0;
		padding-top: 15px;
	}

	.isFixed {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 9999;
	}

	.mianbao_view {
		width: 1480px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		align-items: center;

		.active {
			// font-weight: bold;
			border-bottom: 2px solid #0C8C69
		}
	}

	@media (min-width: 768px) {
		.mianbao_min {
			display: none;
		}

		.middleContent {
			max-width: 1440px;
			width: 100%;
			margin: 0 auto;
			text-align: left;
			margin-top: 50px;
			padding-bottom: 50px;

			.leftView {
				max-width: 856px;
			}

			.rightView {
				margin-left: 120px;
				margin-top: -20px;
				flex: 1;

				.campCase {
					border-radius: 10px;
					padding: 0 18px 18px 0;
					box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
					margin: 15px;
					// width: 453px;
					flex: 1;

					.title {
						font-size: 20px;
						color: #fff;
						background: linear-gradient(to right, #DD9642, #fff);
						height: 40px;
						line-height: 40px;
						padding-left: 20px;
						border-radius: 10px 0 10px 0;
						// text-indent: 20px;
					}

					.caseView {
						// margin: 22px 0 0 20px;
						margin: 0 22px;
						overflow-y: auto;
						max-height: 780px;
					}
				}
			}
		}

		.titleView {
			background-color: #FBFBFB;
			padding: 58px 240px 0 240px;
			width: 100%;

			.titleView_box {
				max-width: 1440px;
				width: 100%;
				margin: 0 auto;

				h4 {
					text-align: left;
				}

				.typeList {
					display: flex;
					flex-direction: row;
					margin-top: 40px;

					.type_item {
						width: 240px;
						height: 208px;
						text-align: center;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						border-top: 3px solid #FBFBFB;

						img {
							margin-top: 10px;
						}

						p {
							margin-top: 46px;
							font-size: 20px;
						}
					}

					.active {
						background-color: #fff;
						border-top: 3px solid #0C8C69;
						font-weight: bold;
					}
				}
			}

		}

		.areaView {
			width: 100%;
			max-width: 1440px;
			margin: 0 auto;
			margin-top: 57px;

			.areaLeft {
				width: 650px;
				margin-right: 70px;
				text-align: left;

				.h5Bottom {
					width: 98px;
					height: 4px;
					background-color: #0C8C69;
					margin-top: 36px;
					margin-bottom: 25px;
				}

				p {
					line-height: 2;
					margin-bottom: 0;
				}
			}

			.img-box {
				// height: 200px;
				// background-color: #cccccc;
				position: relative;

				.play_btn {
					position: absolute;
					top: 50%;
					left: 50%;
					width: 50px;
					height: 50px;
					margin-top: -25px;
					margin-left: -25px;
				}

				.img-box-inner,
				img {
					width: 100%;
					height: 420px;
					overflow: hidden;
					transition: all 0.8s;
					position: relative;
				}
			}
		}

		.middleContent2 {
			padding-bottom: 50px;
		}

		.middleContent3 {
			background-color: #FBFBFB;
			width: 100%;
			padding: 82px 0 104px 0;
			text-align: left;

			.middleContent3_box {
				max-width: 1440px;
				margin: 0 auto;
			}
		}

		.middleContent4 {
			width: 100%;
			max-width: 1440px;
			margin: 0 auto;
			margin-top: 60px;
		}

		.swiperView {
			position: relative;
			margin-top: 40px;

			.swiperBtn {
				position: inherit;
				width: 108%;
				left: -4%;
				top: -152px;

				.swiper-button-next:after,
				.swiper-button-prev:after {
					font-size: 20px;
					color: #999;
				}
			}

		}
	}

	.service_item img {
		object-fit: contain;
	}

	@media (max-width: 768px) {
		.mianbao_min {
			display: flex;
			height: 40px;
			line-height: 35px;
			background-color: #FBFBFB;
			// padding-left: 15px;
			justify-content: space-around;
			text-align: center;
			font-size: 14px;

			.active {
				// font-weight: bold;
				border-bottom: 2px solid #0C8C69;
				color: #0C8C69;
			}
		}

		.mianbao {
			padding-top: 0;
		}

		.mianbao_view {
			display: none;
		}

		.mianbao_item {
			flex: 1;
		}

		.middleContent_min {
			width: 100%;
			margin: 0 auto;
			text-align: left;
			margin-top: 25px;
			padding-bottom: 50px;
			padding: 15px;
			margin-bottom: 25px;

			.leftView {
				// max-width: 856px;
				margin: 0 auto;

			}

			.campCase {
				.title {
					font-size: 20px;
					color: #222;
					height: 40px;
					line-height: 40px;
					// padding-left: 20px;
					// text-indent: 20px;
				}
			}

		}

		.middleContent2_min {

			// padding-bottom: 50px;
			.titleView {
				background-color: #FBFBFB;
				padding: 20px 40px 0 40px;
				width: 100%;

				.titleView_box {
					// max-width: 1440px;
					width: 100%;
					margin: 0 auto;

					h4 {
						text-align: left;
						margin-left: -25px;
					}

					.typeList {
						display: flex;
						flex-direction: row;
						margin-top: 20px;
						justify-content: center;

						.type_item {
							flex: 1;
							// width: 120px;
							// height: 104px;
							text-align: center;
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;
							border-top: 3px solid #FBFBFB;
							padding-top: 20px;

							img {
								margin-top: 10px;
							}

							p {
								margin-top: 20px;
								font-size: 14px;
							}
						}

						.active {
							background-color: #fff;
							border-top: 3px solid #0C8C69;
							font-weight: bold;
						}
					}
				}

			}

			.areaView {
				// width: 100%;
				// max-width: 1440px;
				text-align: left !important;
				margin: 20px 15px;

				.h5Bottom {
					width: 49px;
					height: 2px;
					background-color: #0C8C69;
					margin-top: 18px;
					margin-bottom: 12px;
				}

				.img-box {
					// height: 200px;
					// background-color: #cccccc;
					position: relative;

					.play_btn {
						position: absolute;
						top: 50%;
						left: 50%;
						width: 50px;
						height: 50px;
						margin-top: -25px;
						margin-left: -25px;
					}

					.img-box-inner,
					img {
						width: 100%;
						height: 420px;
						overflow: hidden;
						transition: all 0.8s;
						position: relative;
					}
				}
			}
		}
	}

	.mianbao_item {
		margin: 0 20px;
		padding-bottom: 15px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/page/service.vue